export { default as Overview } from './Overview'
export { default as Contents } from './Contents'
export { default as ContentsPublish, AddContents } from './ContentsPublish'
export { default as FAQ, FAQPublish } from './FAQ'
export { default as Team } from './Team'
export { default as News } from './News'
export { default as NewsDetail } from './News/detail'
export { default as QuickLinksRoutes } from './QuickLinks'
export { default as EditDepartment } from './Edit'
